import React from 'react';
import {
  ChevronLeft16,
  ChevronRight16,
  ArrowLeft16,
  ArrowRight16
} from '@carbon/icons-react';
import { Button } from 'carbon-components-react';

export const ResponsePreviewNavigation = ({
  onScrollLeft,
  onScrollRight
}: {
  onScrollLeft: () => void;
  onScrollRight: () => void;
}) => {
  return (
    <div className="mobile-view-response-nav-container">
      <Button
        kind="secondary"
        className="mobile-view-response-nav-button"
        onClick={onScrollLeft}
      >
        <ChevronLeft16 fill="#000000" />
      </Button>
      <Button
        kind="secondary"
        className="mobile-view-response-nav-button"
        onClick={onScrollRight}
      >
        <ChevronRight16 fill="#000000" />
      </Button>
    </div>
  );
};

export const PreviousResponseButton = ({
  onClick,
  disabled
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <div
      className={`mobile-view-prev-response-button ${
        disabled ? 'mobile-view-response-button-disabled' : ''
      }`}
      onClick={disabled ? undefined : onClick}
    >
      <ArrowLeft16 className="mobile-view-response-arrow-icon" fill="#000000" />
      <div className="mobile-view-response-button-text">
        Previous
        <br />
        response
      </div>
    </div>
  );
};

export const NextResponseButton = ({
  onClick,
  disabled
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <div
      className={`mobile-view-next-response-button ${
        disabled ? 'mobile-view-response-button-disabled' : ''
      }`}
      onClick={disabled ? undefined : onClick}
    >
      <ArrowRight16
        className="mobile-view-response-arrow-icon"
        fill="#000000"
      />
      <div className="mobile-view-response-button-text">
        Next
        <br />
        response
      </div>
    </div>
  );
};
